import { useQuery } from "@tanstack/react-query";
import { get2 } from "../axios";
import { MenuItems } from "../utils/enum";
import { Product } from "../utils/interfaces";
import useBranchId from "./useBranchId";

const useMenuItemHook = <T,>(
  itemType: string,
  sortAlphabetically?: boolean,
) => {
  const branch = useBranchId();

  const query = useQuery<T>({
    queryKey: ["menuItemByType", branch, itemType],
    queryFn: () =>
      get2(`internal/secure/pos/v2/menus/complete/${branch}/${itemType}`, {
        params: {
          sortAlphabetically: sortAlphabetically === false ? 0 : 1,
        },
      }),
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    select: (data) => {
      if (itemType === MenuItems.PRODUCT) {
        const filteredData = (data as Product[]).filter((d) => d.parent_id > 0);
        return filteredData as T;
      }
      return data;
    },
  });

  return query;
};

export default useMenuItemHook;
